export default function StubGlow({ children }) {
  return children;
}
